module.exports = __webpack_public_path__ + "static/media/project_ai_similarities.529264e0.svg";